<template>
  <div class="tab-btn label-content">
    <div class="content">
      <div class="top">
        <SimpleTable
          width="250px"
          :showIndex="false"
          table-code="QuotaListLeft"
          :loading="loading.left"
          :columns="columns.left"
          :data="tableData.left"
        />
        <SimpleTable
          width="250px"
          :showIndex="false"
          table-code="QuotaListCenter"
          :loading="loading.center"
          :columns="columns.center"
          :data="tableData.center"
        />
        <SimpleTable
          :showIndex="false"
          table-code="QuotaListRight"
          :loading="loading.right"
          :columns="columns.right"
          :data="tableData.right"
        />
      </div>
      <div class="bottom">
        <SimpleTable
          :showIndex="false"
          table-code="QuotaListBottom"
          :loading="loading.bottom"
          :columns="columns.bottom"
          :data="tableData.bottom"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SimpleTable from '@/components/SimpleTable/index.vue'
import { sortRecords } from '@/utils/index'

export default {
  name: 'QuotaList',
  inject: ['detailsVm'],
  components: {
    SimpleTable
  },
  props: {
    basicInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: {
        left: false,
        center: false,
        right: false,
        bottom: false
      },
      tableData: {
        left: [],
        center: [],
        right: [],
        bottom: []
      },
      columns: {
        left: [{ field: 'name', title: '定额名称' }],
        center: [{ field: 'name', title: '定额分类' }],
        right: [
          { field: 'name', title: '编码' },
          { field: 'name', title: '子目名称' },
          { field: 'name', title: '单位' },
          { field: 'name', title: '关键词' }
        ],
        bottom: [
          { field: 'name', title: '定额库名称' },
          { field: 'name', title: '编码' },
          { field: 'name', title: '类别' },
          { field: 'name', title: '人材机名称' },
          { field: 'name', title: '规格型号' },
          { field: 'name', title: '单位' },
          { field: 'name', title: '地区含量' },
          { field: 'name', title: '企业含量' },
          { field: 'name', title: '关键词' },
          { field: 'name', title: '更新日期' }
        ]
      }
    }
  },
  watch: {
    basicInfo: {
      handler(newVal) {
        if (newVal) {
          this.init()
        }
      },
      immediate: true
    }
  },
  methods: {
    init() {
      if (!this.basicInfo?.id) return
      this.getTableData()
    },
    async getTableData() {
      this.loading.left = true
      const res = await this.$service.get('/QuotaList/getTableData')
      this.tableData = sortRecords(res.data || [])
      this.loading = false
    }
  }
}
</script>

<style scoped lang="less">
.label-content {
  height: 600px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  .content {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 10px;
    > div {
      flex: 1;
      width: 100%;
    }
    .top {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      gap: 10px;
    }
  }
}
</style>
